import CompiledTranslations from "./assets/generated/CompiledTranslations";

export default class AllTranslationAssets {

    public static t = CompiledTranslations.t;
}